import { defineComponent as _defineComponent } from 'vue'
import OwnerReview from '@/app/components/onboarding/OwnerReview.vue';
import EmployeeReview from '@/app/components/onboarding/EmployeeReview.vue';
import { useAuthStore } from '@/app/store/authStore';
import { computed, onBeforeMount, ref } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';
import { Client } from 'ah-api-gateways';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationPendentView',
  setup(__props) {

const authStore = useAuthStore();

const requestManager = useRequestManager().manager;

const services = getServices();

const client = ref<Client>();

const isOwner = computed(() => authStore.loggedInIdentity?.owner);

function loadClient() {
  requestManager
    .sameOrCancelAndNew('loadClient', services.client.getClient(authStore.loggedInIdentity!.client!.id))
    .subscribe((res) => (client.value = res));
}

function sendToLogin() {
  authStore.logout({
    redirect: 'first-login',
    message: 'Registration completed successfully. Log in to proceed',
  });
}

onBeforeMount(loadClient);

return { __sfc: true,authStore, requestManager, services, client, isOwner, loadClient, sendToLogin, OwnerReview, EmployeeReview }
}

})